import HttpService from "../baseHttp";

//调拨计划列表（服务仓-服务仓
export const HttpAllotList = (data = {}) =>
    HttpService.get("/api/v2/Transfer/findByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });
    

// 创建/编辑调拨单据
export const HttpSaveAllot = (data = {}) =>
    HttpService.post("/api/v2/Transfer/saveOne", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
        headers: { "Content-Type": "application/json" },
        params: { contextId: global.SYSID }
    });

// 查询单条调拨详情
export const HttpAllot = (data = {}) =>
    HttpService.get("/api/v2/Transfer/findOne", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

// 查看发货详情
export const HttpAllotDeliver = (data = {}) =>
    HttpService.get("/api/v2/Transfer/viewShipmentDetailByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

// 清空装箱
export const HttpClearAllotBoxing = (data = {}) =>
    HttpService.post("/api/v2/Transfer/deleteAllBoxItems",data,{
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

// 清空装箱
export const HttpDelAllotBoxing = (data = {}) =>
    HttpService.post("/api/v2/Transfer/deleteBoxItemsByIds", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

// 查看装箱/根据SKU、箱号查看装箱
export const HttpAllotBoxing = (data = {}) =>
    HttpService.get("/api/v2/Transfer/viewBoxDetailByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

// // 装箱逐条添加
export const HttpSaveAllotBoxing = (data = {}) =>
    HttpService.post("/api/v2/Transfer/saveOneItemBox", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
        headers: { "Content-Type": "application/json" },
    });

// /调拨出库计划单提交，删除，取消
export const HttpUpdateAllotStatus = (data = {}) =>
    HttpService.post("/api/v2/Transfer/changeStatus", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

// 装箱完成
export const HttpFinishAllotBoxing = (data = {}) =>
    HttpService.get("/api/v2/Transfer/finishItemBox", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

// /装箱一键添加
export const HttpSaveAllotBoxings = (data = {}) =>
    HttpService.post("/api/v2/Transfer/saveItemBox", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

// 附件

// 附件删除
export const HttpDelAllotFile = (data = {}) =>
    HttpService.get("/api/v2/Transfer/delAnnex", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

    
//通过项目获取产品
export const HttpSkuList = (data = {}) =>
HttpService.get("/api/v1/Product/findByLineId", {
    params: data,
    baseURL: process.env.VUE_APP_APIURL_BOSS
});
//查询产品行中的erpsku，再关联查询产品中心
export const HttpErpSkuList = (data = {}) =>
    HttpService.get("/api/v2/Transfer/findItemErpSkuByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

// erpsku 查询 编辑/创建页面 库存数量
export const HttpInventoryErpSkuList = (data = {}) =>
    HttpService.get("/api/v2/vendor/Inventory/findInventory", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

//调拨产品行分页查询
export const HttpAllotProductList = (data = {}) =>
    HttpService.get("/api/v2/Transfer/viewPlanItemByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });
//生成箱标
export const HttpAllotBoxingLabel = (data = {}) =>
    HttpService.get("/api/v2/Transfer/generateBoxLabel", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });


//生成取消
export const HttpCancelAllot = (data = {}) =>
    HttpService.get("/api/v2/Transfer/batchCancel", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

    export const HttpSureAllot = (data = {}) =>
    HttpService.get("/api/v2/Transfer/sure", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

export const HttpConfirmAllot = (data = {}) =>
    HttpService.get("/api/v2/Transfer/batchConfirm", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });

export const HttpSubmitAllot = (data = {}) =>
HttpService.get("/api/v2/Transfer/batchSubmit", {
    params: data,
    baseURL: process.env.VUE_APP_APIURL_FBB
});


//地址codelist
export const HttpAddressCodeList = (data = {}) =>
    HttpService.get("/api/v2/address/findByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB
    });
    


// 根据onsite仓库请求渠道列表
export const HttpFindByOrgIdAndOrgWarehouseId = (data = {}) => 
    HttpService.get('/api/v2/accountChannel/findByOrgIdAndOrgWarehouseId', { 
        params: data, 
        baseURL: process.env.VUE_APP_APIURL_FBB 
    });



    